"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TransactionCard_1 = __importDefault(require("@/components/dataCard/TransactionCard"));
const fetchData_1 = require("@/utils/fetchData");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Section_1 = __importDefault(require("@/components/layout/Section"));
const styled_components_1 = require("styled-components");
const themes_1 = require("@/theme/themes");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const LedgerTransactionSpecific = () => {
    const params = (0, react_router_dom_1.useParams)();
    const [transaction, setTransaction] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const getData = async () => {
        setIsLoading(true);
        try {
            const result = await Promise.all([(0, fetchData_1.getTransactionDetailsByTxhash)(params.txhash)]);
            const [transactionResult] = await Promise.all(result);
            setTransaction(transactionResult);
            setIsLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    if (transaction) {
        return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                    react_1.default.createElement(TransactionCard_1.default, { data: transaction })))));
    }
};
exports.default = LedgerTransactionSpecific;
